import { QueryClient } from '@tanstack/react-query';
import { isNormalizedApiError } from '@/types/api';

/**
 * queryClient.ts - Section 49.2: TanStack Query owns ALL server state
 * (trips, bookings, payments, ...). Sensible defaults here mean individual
 * `useQuery` calls rarely need to override anything.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // most TripLink data (trip lists, prices) changes often enough that 30s is a safe default
      retry: (failureCount, error) => {
        // Never retry on 4xx (validation/auth/not-found) - only transient
        // network/5xx errors are worth an automatic retry.
        if (isNormalizedApiError(error) && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false, // never auto-retry a mutation (Section 16.5: duplicate-submission protection) - the idempotency key belongs on the request itself, not a blind client retry
    },
  },
});
